export default "__VITE_ASSET__Ci_uORbI__"